import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const EnrollmentRoutes: Routes = [
  {
    path: "enroll",
    loadComponent: () =>
      import("./enrollment/enrollment.component").then(
        (m) => m.EnrollmentComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "member",
        loadComponent: () =>
          import("./enroll-member/enroll-member.component").then(
            (m) => m.EnrollMemberComponent,
          ),
      },
    ],
  },
];
